import { ChangeDetectionStrategy, Component, inject, OnInit, Input } from '@angular/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { TuiDialogContext } from '@taiga-ui/core';
import { BaseComponent } from '@src/app/modules/base';

import { CategoriesStoreKeys, LoyaltyProgramFilterService, LpCategoriesStoreService } from '../../services';
import { GroupItem } from '../../types';

@Component({
  selector: 'app-categories-dialog',
  templateUrl: './categories-dialog.component.html',
  styleUrls: ['./categories-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesDialogComponent extends BaseComponent implements OnInit {
  private readonly loyaltyProgramFilterService = inject(LoyaltyProgramFilterService);
  private readonly lpCategoriesStore = inject(LpCategoriesStoreService);
  private readonly context = injectContext<TuiDialogContext<string[] | undefined, string>>();

  @Input() maxCategories = 5;

  selectedCategories: GroupItem[] = [];
  loading = false;

  categories?: ReadonlyArray<GroupItem>;

  get selectedIds() {
    return this.context.data;
  }

  ngOnInit(): void {
    this.loyaltyProgramFilterService.getCategories(true);

    this.lpCategoriesStore.getDataObservable(CategoriesStoreKeys.InUse).subscribe(categories => {
      this.categories = categories;
      if (!categories) return;

      if (categories.length) {
        if (!this.selectedCategories.length) {
          this.selectedCategories = categories.filter(category => this.selectedIds.includes(category.id));
        }

        this.loading = false;
      } else {
        this.complete();
      }

      this.cdr.markForCheck();
    });
  }

  isCategorySelected(category: GroupItem) {
    return Boolean(this.selectedCategories.find(selectedCategory => selectedCategory.id === category.id));
  }

  clickCategory(category: GroupItem) {
    const categoryIndex = this.selectedCategories.findIndex(selectedCategory => selectedCategory.id === category.id);

    if (categoryIndex === -1) {
      if (this.selectedCategories.length < this.maxCategories) {
        this.selectedCategories.push(category);
      }
    } else {
      this.selectedCategories.splice(categoryIndex, 1);
    }
  }

  complete() {
    this.context.completeWith(undefined);
  }

  save() {
    const selectedCategoriesIds = this.selectedCategories.map(category => category.id);
    this.loading = true;

    this.context.completeWith(selectedCategoriesIds);
  }
}
